import React from 'react';
import { CheckCircle2, XCircle, Info, CircleSlash } from 'lucide-react';
import type { CheckStatus } from '../../utils/verification';
const styles: Record<CheckStatus, {
  label: string;
  cls: string;
  Icon: typeof Info;
}> = {
  match: {
    label: 'Coincide',
    cls: 'bg-emerald-400/10 text-emerald-200 border-emerald-400/30',
    Icon: CheckCircle2
  },
  mismatch: {
    label: 'Diferencia',
    cls: 'bg-red-400/10 text-red-200 border-red-400/30',
    Icon: XCircle
  },
  info: {
    label: 'Sin referencia',
    cls: 'bg-white/[0.04] text-gray-300 border-white/15',
    Icon: Info
  },
  unavailable: {
    label: 'No comprobado',
    cls: 'bg-amber-300/10 text-amber-100 border-amber-300/30',
    Icon: CircleSlash
  }
};
export function StatusBadge({
  status,
  label
}: {
  status: CheckStatus;
  label?: string;
}) {
  const s = styles[status];
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-semibold ${s.cls}`} data-id="element-1847" data-mp="1uepbiv5h75yi">
      <s.Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1848" data-mp="1qddfo7w0dohv" />
      {label ?? s.label}
    </span>;
}

/** Valor real cargado: siempre en blanco y monoespaciado. */
export function Actual({
  value
}: {
  value?: string;
}) {
  if (value === undefined) return <span className="text-sm text-amber-200/90" data-id="element-1849" data-mp="3i30xkxhpz79c">No comprobado</span>;
  return <span className="font-mono text-[15px] font-semibold text-white" data-id="element-1850" data-mp="3i5wxgrd4o60f">{value}</span>;
}

/** Valor de referencia: siempre atenuado, nunca se presenta como resultado. */
export function Expected({
  value
}: {
  value?: string;
}) {
  if (value === undefined) return <span className="text-sm text-gray-600" data-id="element-1851" data-mp="2uf1b49rfy30k">—</span>;
  return <span className="font-mono text-sm text-gray-500" data-id="element-1852" data-mp="2zd2ruo1e9q8v">{value}</span>;
}
export function EmptyOk({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="flex items-center gap-2 rounded-2xl border border-white/10 px-4 py-3 text-sm text-gray-300" data-id="element-1853" data-mp="34dqrtz7lphf8">
      <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-300" aria-hidden="true" data-id="element-1854" data-mp="emkge2vg4vbr" />
      {children}
    </p>;
}